import { render } from "./HomeVue.vue?vue&type=template&id=d3c527d8"
import script from "./HomeVue.vue?vue&type=script&lang=js"
export * from "./HomeVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__